import type { Firestore } from "firebase/firestore/lite";
import { getFirebaseApp } from "./app";

// firebase/firestore/lite is een aparte SDK-chunk — dynamisch geladen (gecacht) i.p.v. statisch
// gebundeld, zodat 'ie niet meer meeloopt in de kritieke eerste-bundel op élke pagina (zie
// lib/firebase/auth.ts voor hetzelfde patroon, eerder toegepast op firebase/auth).
let firestoreModPromise: Promise<typeof import("firebase/firestore/lite")> | null = null;
export function loadFirestoreModule(): Promise<typeof import("firebase/firestore/lite")> {
  if (!firestoreModPromise) firestoreModPromise = import("firebase/firestore/lite");
  return firestoreModPromise;
}

// This project's Firestore is the named database "database" (no (default) exists).
let db: Firestore | null = null;
export async function getDb(): Promise<Firestore> {
  if (db) return db;
  const { getFirestore } = await loadFirestoreModule();
  db = getFirestore(getFirebaseApp(), "database");
  return db;
}
